import { Button, Modal } from "flowbite-react";
import { useState } from "react";
import Select from "react-select";
import { useGetAgentsQuery } from "@/api/agentApi/agent";
import { Agent } from "@/sharedTypes";
import { useTranslation } from "react-i18next";

interface AgentListDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (agentIds: string[]) => void;
}

const AgentListDialog = ({ open, onClose, onSubmit }: AgentListDialogProps) => {
  const { t } = useTranslation(["group", "common"]);
  const [selectedAgents, setSelectedAgents] = useState<string[]>([]);
  const { data: agentsData } = useGetAgentsQuery({ pagination: { page: 1, pageSize: 100 }, filters: {} });
  
  const options = agentsData?.items?.map((agent: Agent) => ({
    label: agent.agent_username,
    value: agent.agent_id.toString(),
  })) || [];

  const handleSubmit = () => {
    onSubmit(selectedAgents);
    onClose();
  };

  return (
    <Modal show={open} onClose={onClose}>
      <Modal.Header>{t("group:addAgentToGroup")}</Modal.Header>
      <Modal.Body>
        <div className="space-y-4">
            <Select
                isMulti
                options={options}
                onChange={(newValue) => setSelectedAgents(newValue.map((v: any) => v.value))}
                placeholder={t("group:selectAgents")}
            />
            <div className="flex justify-end gap-2">
                <Button color="failure" onClick={onClose}>{t("common:cancel")}</Button>
                <Button onClick={handleSubmit}>{t("group:addAgents")}</Button>
            </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AgentListDialog;
